module.exports = __webpack_public_path__ + "static/5.2a_ADIDAS_DC_WW-f5997860c96ef3b2d32be6401434aea0.gif";